import api from '@/api';
import {
  MailHistoryInterface,
  MailHistoryParamsInterface,
} from './MailHistory.types';
import { API_BASE_URL } from '..';
import { PageResult } from '@/core/request/PageResult';

const BASE_URL = API_BASE_URL + '/mail/filter';

export async function getMailHistory(params?: MailHistoryParamsInterface) {
  const result = (await api.get(BASE_URL, params)) as unknown;
  return result as PageResult<MailHistoryInterface>;
}
